/**
 * Chirurgie viscérale — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: GAST
 * Catalogue acts (NGAP Maroc): 124
 */
import { defineSpecialty } from "../types";

export const chirurgie_viscerale = defineSpecialty(
{
  "id": "chirurgie-viscerale",
  "label": "Chirurgie viscérale",
  "short": "Chir. viscérale",
  "scope": "Chirurgie digestive et viscérale",
  "aliases": [
    "GAST"
  ],
  "doctorSpecs": [
    "Chirurgie générale",
    "Chirurgie viscérale"
  ],
  "featureFlag": "ux.v2.chirurgie-viscerale",
  "theme": {
    "primary": "oklch(0.70 0.14 60)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 2,
      "requires": [
        "imaging"
      ]
    },
    {
      "id": "endoscopy",
      "label": "Endoscopie",
      "icon": "Scan",
      "route": "/clinical/endoscopy",
      "order": 3,
      "requires": []
    },
    {
      "id": "surgery",
      "label": "Bloc",
      "icon": "Syringe",
      "route": "/clinical/surgery",
      "order": 4,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "component": "ClinicalImageGallery",
      "order": 1,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 2,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Chirurgie viscérale",
    "subSpecialties": [
      "Consultation",
      "Cœlioscopie",
      "Gastroscopie",
      "Chirurgie"
    ],
    "catalogueActs": 123
  },
  "terminology": {
    "icd10": [
      "K20",
      "K35",
      "K40",
      "K70",
      "K80"
    ],
    "loinc": [
      "33717-0",
      "17849-1"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "gastroscope",
    "coloscope",
    "laparoscope"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default chirurgie_viscerale;
